// extracted by css-extract-rspack-plugin
export default {"container":"_269586cc","topContent":"_19e92389","hasCreateProfile":"_6bac693e","createProfileButton":"_b17bcd92","floatingButton":"_8d8578ad"};